import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const addObj = (params, urlParams) => {
  return axios.request({
    url: '/cpc/vehiclemaintenanceplan/add' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/cpc/vehiclemaintenanceplan/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/cpc/vehiclemaintenanceplan/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/cpc/vehiclemaintenanceplan/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const modifyObj = (params, urlParams) => {
  return axios.request({
    url: '/cpc/vehiclemaintenanceplan/modify' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const deleteObj = (params, urlParams) => {
  return axios.request({
    url: '/cpc/vehiclemaintenanceplan/' + params.id + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const getMyAll = (params, urlParams) => {
  return axios.request({
    url: '/cpc/vehiclemaintenanceplan/getmyall' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getMyPage = (params, urlParams) => {
  return axios.request({
    url: '/cpc/vehiclemaintenanceplan/getmypage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const confirmRemind = (params, urlParams) => {
  return axios.request({
    url: '/cpc/vehiclemaintenanceplan/confirmremind/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

